// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JGEXNtVeatgEgC {
  flex-basis: 100%;
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0);
  padding-left: var(--ds-space-150, 12px);
  color: var(--accent-text, var(--ds-text-subtlest, #626f86));
  line-height: 16px;
}
.rTTPtQPFpkzGIO {
  order: 2;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0);
  color: var(--accent-text, var(--ds-text-subtlest, #626f86));
}
`, ""]);
// Exports
export var filteredCardCount = `JGEXNtVeatgEgC`;
export var collapsedCardCount = `rTTPtQPFpkzGIO`;
export default ___CSS_LOADER_EXPORT___;
